import classNames from 'classnames';
import styled from 'styled-components';

const StyledImg = styled.img`
  object-fit: contain;

  &:not(.selected) {
    filter: grayscale(1);
  }
`;

type Props = {
  badgeUrl: string;
  title: string;
  selected?: boolean;
  width?: number;
};

export const DivisionIcon = ({
  badgeUrl,
  title,
  selected,
  width = 32,
}: Props) => {
  return (
    <StyledImg
      src={badgeUrl}
      className={classNames({ selected })}
      alt={title}
      width={width}
    />
  );
};
